import { QueryCache, QueryClient } from '@tanstack/react-query';
import { showApiErrorSnack } from './show-api-error-snack';

function shouldSkipQueryErrorSnack(query) {
  if (query.meta?.skipErrorSnack) {
    return true;
  }
  const [root] = query.queryKey;
  return root === 'session';
}

/** Shared TanStack Query client — see docs/migrations/03-tanstack-query-zustand.md */
export function createAppQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (shouldSkipQueryErrorSnack(query)) {
          return;
        }
        showApiErrorSnack(error);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
